import * as actions from './actions';
import { videoSchema } from './schemas';
import { handle } from './service';
import { ACTION_KEY, ServiceMethod } from './types';

export * from './types';
export { UploadVideoOptions } from './types';
export { actions, videoSchema };

export default {
  handle,
  ActionKey: ACTION_KEY,
  Method: ServiceMethod,
};
